import { render, staticRenderFns } from "./organization-risk-list-view.vue?vue&type=template&id=00ba0414&scoped=true"
import script from "./organization-risk-list-view.vue?vue&type=script&lang=js"
export * from "./organization-risk-list-view.vue?vue&type=script&lang=js"
import style0 from "./organization-risk-list-view.vue?vue&type=style&index=0&id=00ba0414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba0414",
  null
  
)

export default component.exports